export default __webpack_public_path__ + "static/media/926.0098ccd5.jpg";